export default {"src":"/_next/static/media/dollar-hand.77cd146b.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};